import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	downloadingCsvFile: {
		id: 'issue-navigator-action-export-issues.common.download-flag.downloading-csv-file',
		defaultMessage: 'Downloading {fileExtension} file',
		description: 'Label that indicates downloading is in progress',
	},
	downloadingProgressBarAriaLabel: {
		id: 'issue-navigator-action-export-issues.common.download-flag.downloading-progress-bar-aria-label',
		defaultMessage: 'Downloading in progress',
		description: 'Aria label for the indeterminate progress bar',
	},
});

export default messages;
